import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { Stack, Typography as MuiTypography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router";
import { AnchoredPopover, Button, FoodsIcon, Typography } from "@foodpilot/foods";
import { Fragment, useState } from "react";
import ImportIcon from "src/assets/icons/import.svg?react";
import { ComingSoonBadge } from "src/components/ComingSoonBadge";
import { CreateNewMenuItem } from "src/components/CreateNewMenuItem";
import { CREATE, INGREDIENT, useFoodpilotContext } from "src/context/FoodpilotContext.tsx";
import { URLHandler } from "src/services/URLHandler";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";

export const IngredientPopover = () => {
    const { t } = useTranslation();
    const { canUser } = useFoodpilotContext();
    const isProductUxV2 = useIsProductUxV2();

    const [anchor, setAnchor] = useState<null | HTMLElement>(null);
    const isOpen = Boolean(anchor);

    return (
        <Fragment>
            {canUser(CREATE, INGREDIENT) && (
                <Button
                    variant="primary"
                    id="create-product-button"
                    onClick={(e) => setAnchor(e.currentTarget)}
                    endIcon={isProductUxV2 ? <FoodsIcon icon="arrowDownShort" size={1} /> : <KeyboardArrowDown />}
                >
                    {t("creer_de_nouveaux_ingredients")}
                </Button>
            )}
            <AnchoredPopover
                variant="themed"
                anchor={anchor}
                open={isOpen}
                onClose={() => setAnchor(null)}
                anchorPosition="rightside"
            >
                <IngredientMenu isProductUxV2={isProductUxV2} />
            </AnchoredPopover>
        </Fragment>
    );
};

const IngredientMenu = ({ isProductUxV2 }: { isProductUxV2: boolean }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { selectedCompany } = useFoodpilotContext();

    if (selectedCompany === null) return;
    return (
        <Stack padding="0" gap="20px">
            <CreateNewMenuItem
                appearance={isProductUxV2 ? "product-v2" : "legacy"}
                onClick={() => {
                    const currentUrl = location.pathname + location.search;
                    const createUrl = URLHandler.ingredient.create(selectedCompany.id, 0);
                    navigate(`${createUrl}?returnUrl=${encodeURIComponent(currentUrl)}`);
                }}
            >
                {isProductUxV2 ?
                    <FoodsIcon icon="add" size={2} />
                :   <AddCircleOutline />}
                {isProductUxV2 ?
                    <Typography sx={theme.custom.rowMenuElement}>{t("creer_un_ingredient")}</Typography>
                :   <MuiTypography sx={theme.custom.rowMenuElement}>{t("creer_un_ingredient")}</MuiTypography>}
            </CreateNewMenuItem>
            <CreateNewMenuItem appearance={isProductUxV2 ? "product-v2" : "legacy"} disabled>
                <ImportIcon />
                {isProductUxV2 ?
                    <Typography sx={theme.custom.rowMenuElement}>{t("importer_des_ingredients")}</Typography>
                :   <MuiTypography sx={theme.custom.rowMenuElement}>{t("importer_des_ingredients")}</MuiTypography>}
                <ComingSoonBadge />
            </CreateNewMenuItem>
        </Stack>
    );
};
